import { NormalLoading } from "@/Icons";
import React from "react";

const Home = () => {
  return (
    <div className="flex h-[calc(100vh-56px)] items-center justify-center bg-[#EBECF2]">
      <NormalLoading className="text-[24px]" spin={true} />
    </div>
  );
};

export default Home;
